import { render, staticRenderFns } from "./CustomizeLandingPage.vue?vue&type=template&id=773f2446&scoped=true"
import script from "./CustomizeLandingPage.vue?vue&type=script&lang=js"
export * from "./CustomizeLandingPage.vue?vue&type=script&lang=js"
import style0 from "./CustomizeLandingPage.vue?vue&type=style&index=0&id=773f2446&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "773f2446",
  null
  
)

export default component.exports